<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AAHhC6/tc-custom/9780253044242.jpg?1718170132880" alt="This image is the cover for the book Battle for Malaya"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Battle for Malaya
      </h1>
      <p class="bookDescription body article font2">
        <b>The historian and author of <i>The Army in British India</i> analyzes the British Indian Army’s devastating loss to the Imperial Japanese during WWII.</b><br/><br/>The defeat of 90,000 Commonwealth soldiers by 50,000 Japanese soldiers made the World War II Battle for Malaya an important encounter for both political and military reasons. British military prestige was shattered, fanning the fires of nationalism in Asia, especially in India. Japan’s successful tactics in Malaya—rapid marches, wide outflanking movement along difficult terrain, nocturnal attacks, and roadblocks—would be repeated in Burma in 1942–43. Until the Allied command evolved adequate countermeasures, Japanese soldiers remained supreme in the field. <br/><br/>Looking beyond the failures of command, Kaushik Roy focuses on tactics of the ground battle that unfolded in Malaya between December 1941 and February 1942. His analysis includes the organization of the Indian Army—the largest portion of Commonwealth troops—and compares it to the British and Australian armies that fought side by side with Indian soldiers. Utilizing both official war office records and personal memoirs, autobiographies, and oral histories, Roy presents a comprehensive narrative of operations interwoven with tactical analysis of the Battle for Malaya.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kaushik Roy
      </h2>
      
      <p class="authorDescription body article"><P>Kaushik Roy is Associate Professor, Department of History, Jadavpur University, Kolkata, West Bengal, India and Senior Researcher at Peace Research Institute Oslo (PRIO), Norway. He has written or edited 19 books, including most recently <I>War, Culture and Society in Early Modern South Asia, 1740-1849</I>, <I>Hinduism and the Ethics of Warfare in South Asia</I>, and <I>The Army in British India.</I></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?347e41af